module.exports = __webpack_public_path__ + "static/blue-spinner-c80b7bf250f9492f31271841727e8f68.gif";